import { render, staticRenderFns } from "./detaild.vue?vue&type=template&id=f34d7d1a&"
import script from "./detaild.vue?vue&type=script&lang=js&"
export * from "./detaild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports